import { render } from "./protocol_info_head.vue?vue&type=template&id=a84f794e"
import script from "./protocol_info_head.vue?vue&type=script&lang=js"
export * from "./protocol_info_head.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/protocol/create/blocks/protocol_info_head.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a84f794e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a84f794e', __exports__)) {
    console.log('reload')
    api.reload('a84f794e', __exports__)
  }
  
  module.hot.accept("./protocol_info_head.vue?vue&type=template&id=a84f794e", () => {
    console.log('re-render')
    api.rerender('a84f794e', render)
  })

}


export default __exports__